const MegaMenu = () => {
  // var dataKey;

  // Define our viewportWidth variable
  // var viewportWidth;

  // Set/update the viewportWidth value
  // var setViewportWidth = function () {
  //   viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  // }

  // var logWidth = function () {
  //   if (viewportWidth > 1169) {

  $('.header #menu-1').hover(
    function () {
      $('.sub-dropdown-menu').stop(true, true).delay(0).fadeOut(200);
      $('#sub-menu').stop(true, true).delay(200).fadeIn(200);
      $('.overlay--body').addClass('overlay--active');
    },
    function () {
      $('#sub-menu').stop(true, true).delay(1500).fadeOut(100);
      $('.overlay--body').removeClass('overlay--active');
    }
  );

  $('.sub-dropdown-menu').hover(
    function () {
      $(this).stop(true, true).delay(200).fadeIn(200);
      $('.overlay--body').addClass('overlay--active');
    },
    function () {
      $(this).stop(true, true).delay(1500).fadeOut(100);
      $('.overlay--body').removeClass('overlay--active');
    }
  );

  // }

  // // Set our initial width and log it
  // setViewportWidth();
  // logWidth();

  // // On resize events, recalculate and log
  // window.addEventListener('resize', function () {
  //   setViewportWidth();
  //   logWidth();
  // }, false);
};

export default MegaMenu;
